import { ReactNode } from 'react';

interface CoverProps {
  children: ReactNode;
}

export function Cover({ children }: CoverProps) {
  return (
    <div className="component-cover">
      {children}
    </div>
  );
}
